import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  viewChildren,
  ViewChildren,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { debounceTime, finalize, firstValueFrom, Observable, Subject } from 'rxjs';
import { Ambito } from 'src/app/services/ambiti/ambiti.service';
import { AziendaService } from 'src/app/services/azienda/azienda.service';
import { ValoriKpi } from 'src/app/services/KPI/kpi.service';
import {
  CompilaTematiche,
  ReportVsmeService,
} from 'src/app/services/report-vsme/report-vsme.service';
import { OpzioneTematica, Tematica } from 'src/app/services/tematiche/tematiche.service';
import {
  UnitaDiMisura,
  UnitaDiMisuraService,
} from 'src/app/services/unita-di-misura/unita-di-misura.service';
import { UtenteIncaricatoService } from 'src/app/services/utente/utente-incaricato.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { TipoElemento, UtilityService } from 'src/app/services/utility/utility.service';
import { SwiperContainer } from 'swiper/element';
import { ElementoForAI } from '../app-follia-widget/chat-data-interface';
import { Filters } from '../lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottomSheetInfoElementiComponent,
  InfoElemento,
} from '../selezione-elementi-questionario/bottom-sheet-info-elementi/bottom-sheet-info-elementi.component';
import { DialogAssociaFiguraAziendaleComponent } from '../selezione-elementi-questionario/dialog/dialog-associa-figura-aziendale/dialog-associa-figura-aziendale.component';
import { SpinnerOverlayComponent } from '../spinner-overlay/spinner-overlay.component';
import { TabellaDinamica } from '../tabella-cfg-dinamica/tabella-cfg-dinamica.component';

@Component({
  selector: 'app-compila-risposte-tematiche',
  standalone: false,

  templateUrl: './compila-risposte-tematiche.component.html',
  styleUrl: './compila-risposte-tematiche.component.scss',
})
export class CompilaRisposteTematicheComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Output() completato: EventEmitter<boolean> = new EventEmitter();

  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild('swiperAmbiti') swiperAmbiti!: ElementRef<SwiperContainer>;
  @ViewChildren('swiperTematiche') swiperTematiche!: QueryList<ElementRef<SwiperContainer>>;

  // 1. viewChildren signal per ottenere la lista di tutte le textarea con #textArea
  private readonly textAreas = viewChildren<ElementRef<HTMLTextAreaElement>>('textArea');

  // 2. Lista di textarea che si osservano il cambiamento, lista per poi disattivarle tutte nel destroy
  private observers: ResizeObserver[] = [];
  // 3. Subject che viene notificato quando una textarea cambia, cosi da aggiornare l'altezza dello swiper con debounce e evitare sovraccarichi
  private readonly resizeSubject = new Subject<void>();

  private readonly utenteIncaricatoService = inject(UtenteIncaricatoService);

  private _salva?: (
    idModulo: string,
    compilazione: CompilaTematiche | undefined,
  ) => Observable<boolean>;

  @Input()
  set salva(
    salva: (idModulo: string, compilazione: CompilaTematiche | undefined) => Observable<boolean>,
  ) {
    this._salva = salva;
  }

  private _compilazione: CompilaTematiche | undefined;
  @Input()
  set compilazione(compilazione: CompilaTematiche | undefined) {
    this.isReady = false;
    this._compilazione = compilazione;

    this.totTematiche = 0;

    this.ambiti.forEach((ambito, idxTema) => {
      this.totTematiche += ambito.tematiche.length;
    });
    this._updateSwiperHeight();
  }

  public isReady: boolean = false;

  get compilazione() {
    return this._compilazione!;
  }

  private _idModulo!: string;

  @Input()
  set idModulo(idModulo: string) {
    this._idModulo = idModulo;
  }

  get idModulo() {
    return this._idModulo;
  }

  private _disableForm: boolean = false;

  @Input()
  set disableForm(disableForm: boolean) {
    this._disableForm = disableForm;
  }

  get disableForm() {
    return this._disableForm;
  }

  private _tipoModulo: 'AUTOVALUTAZIONE' | 'REPORT_VSME' = 'AUTOVALUTAZIONE';
  @Input()
  set tipoModulo(tipoModulo: 'AUTOVALUTAZIONE' | 'REPORT_VSME') {
    this._tipoModulo = tipoModulo;
    this.risposteDaCiclare = this._tipoModulo === 'AUTOVALUTAZIONE' ? 'opzioni' : 'risposteVsme';
  }

  get tipoModulo() {
    return this._tipoModulo;
  }

  private _temporaryToken: string | undefined = undefined;

  @Input()
  set temporaryToken(temporaryToken: string | undefined) {
    this._temporaryToken = temporaryToken;
  }

  get temporaryToken() {
    return this._temporaryToken;
  }

  get isVsme() {
    return this.tipoModulo === 'REPORT_VSME';
  }

  get isAutovalutazione() {
    return this.tipoModulo === 'AUTOVALUTAZIONE';
  }

  get ambiti(): Ambito[] {
    return this.compilazione?.ambiti || [];
  }

  get isIntegrazioneAI() {
    return this.utenteIncaricatoService.isIntegrazioneIA();
  }
  public risposteDaCiclare: 'opzioni' | 'risposteVsme' = 'opzioni';
  public currentSlideIndex: number = 0;
  public totTematiche = 0;
  public titoloBtnAvanti = 'Avanti';
  public indexAmbitoCorrente = 0;
  public indexTematicaCorrente = 0;
  public mappaPunteggioAmbiti: { [key: string]: any } = {};

  public arrayUm: { [idKpi: string]: UnitaDiMisura[] } = {};

  constructor(
    private readonly utilityService: UtilityService,
    private readonly unitaDiMisuraService: UnitaDiMisuraService,
    private readonly reportVsmeService: ReportVsmeService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly aziendaService: AziendaService,
    public dialog: MatDialog,
    private readonly _bottomSheet: MatBottomSheet,
    private readonly utenteService: UtenteService,
  ) {
    this.resizeSwiperAfterTextAreaResized();
  }

  ngOnDestroy() {
    this.cleanupObservers();
  }

  ngAfterViewInit(): void {
    this.isReady = false;
    if (this.isVsme) {
      this._listaFigureAz();
    }

    this.initSwiper();
    this.cdRef.detectChanges();
    this.isReady = true;
  }

  initSwiper() {
    setTimeout(() => {
      if (this.disableForm) {
        this.swiperAmbiti.nativeElement.swiper.slideTo(0);
      } else {
        this.moveToTematicaSenzaRisposte();
      }
    }, 0);
    this._getUnitaDiMisuraPerKpi();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changeCompilazione = changes['compilazione'];
    const isCambiato = changeCompilazione?.currentValue && !changeCompilazione?.firstChange;

    if (isCambiato && this.isVsme) {
      setTimeout(() => {
        this.moveToTematicaSenzaRisposte();
      }, 0);
    }
  }

  /**
   * Metodo che cicla tutte le tematiche e trova la prima tematica senza risposte, se è presente, altrimenti ritorna undefined
   * Se la risposta della temtaica è checkata, allora controllo anche che abbia alemno una sotto risposta checkata, altrimenti la tematica viene considerata senza risposte
   * @returns
   */
  private findTematicaSenzaRisposte(): {
    indiceAmbito?: number;
    indiceTematica?: number;
    currentSlideIndex: number;
  } {
    // 1. Guard, se già pubblicato, non serve controllare
    if (this._compilazione?.stato === 'PUBBLICATO') {
      return { indiceAmbito: undefined, indiceTematica: undefined, currentSlideIndex: 0 };
    }

    let currentSlideIndex = 0;

    for (let idxAmb = 0; idxAmb < this.ambiti.length; idxAmb++) {
      const tematiche = this.ambiti[idxAmb].tematiche || [];

      // 2. Troviamo l'indice della prima tematica che fallisce la validazione
      const idxTemaIncompleto = tematiche.findIndex((tema) => {
        const haRisposte = !!tema.risposte?.length;
        const haSottoOpzioniValide = haRisposte && this.isSottoOpzioneChecked(tema);

        return !haRisposte || !haSottoOpzioniValide;
      });

      // 3. Se l'abbiamo trovata, restituiamo i dati per navigare direttamente a quella tematica
      if (idxTemaIncompleto !== -1) {
        return {
          indiceAmbito: idxAmb,
          indiceTematica: idxTemaIncompleto,
          currentSlideIndex: currentSlideIndex + idxTemaIncompleto,
        };
      }

      // 4. Incrementiamo il contatore globale delle slide solo se l'ambito è "completo"
      currentSlideIndex += tematiche.length;
    }

    return { indiceAmbito: undefined, indiceTematica: undefined, currentSlideIndex: 0 };
  }

  public moveToTematicaSenzaRisposte(): boolean {
    const target = this.findTematicaSenzaRisposte();

    // Se indiceAmbito è undefined, significa che tutte le tematiche hanno risposte
    if (target.indiceAmbito === undefined) {
      return false;
    }

    // Aggiorniamo l'indice globale (usando il valore calcolato dal finder)
    this.currentSlideIndex = target.currentSlideIndex;

    // 1. Gestione Swiper Padre (Ambiti)
    const swiperPadre = this.swiperAmbiti?.nativeElement?.swiper;
    if (swiperPadre) {
      swiperPadre.slideTo(target.indiceAmbito);
    }

    // 2. Gestione Swiper Figlio (Tematiche all'interno dell'ambito)
    const swiperFiglioRef = this.swiperTematiche.get(target.indiceAmbito);
    if (swiperFiglioRef) {
      const swiperFiglio = swiperFiglioRef.nativeElement.swiper;
      swiperFiglio.slideTo(target.indiceTematica || 0);

      // Sincronizziamo l'indice locale
      this.indexTematicaCorrente = swiperFiglio.realIndex;
    }

    return true; // Indica che è stata trovata una tematica vuota e ci siamo spostati
  }

  /**
   * Gestione per la visualizzazione della categoria e unità di misura dei kpi
   */
  private _getUnitaDiMisuraPerKpi(): void {
    for (const ambito of this.ambiti) {
      if (!ambito.tematiche?.length) continue;

      for (const tematica of ambito.tematiche) {
        const risposte = tematica[this.risposteDaCiclare];
        if (!risposte?.length) continue;

        for (const opzione of risposte) {
          if (!opzione.sottoOpzioni?.length) continue;

          for (const sottoOpzione of opzione.sottoOpzioni) {
            const idCategoria = sottoOpzione.idCategoriaUnitaDiMisura;
            const isKpi = sottoOpzione.tipo === 'kpi';
            const isAlreadyLoaded = !!this.arrayUm[idCategoria];

            if (!isKpi || !idCategoria) continue;

            /*
            (RISOLUZIONE BUG VALORI KPI VUORI SU ASSESSMENT)
            Se valori kpi vuoto, genero l'oggetto valoriKpi di defeault.
            Perde i valori di compilazioni perchè non vengono salvati al di fuori del oggetto valoriKpi che
            stranamente per qualche condizione / sincronizzatore lo perde. Questo if viene fatto solamente per 
            sbloccare gli assessment danneggiati 
            */
            if (!sottoOpzione.valoriKpi.length && this._compilazione?.esercizio) {
              const anno: number = parseInt(this._compilazione?.esercizio[0], 10);
              const idUnitaDiRiferimento = sottoOpzione.idUnitaDiRiferimento;

              const valoriKpi: ValoriKpi = {
                anno: anno,
                idCategoriaUnitaDiMisura: idCategoria,
                idUnitaDiRiferimento: idUnitaDiRiferimento,
                tipo: 'valore_kpi',
                valoreAttribuito: undefined,
              };

              sottoOpzione.valoriKpi.push(valoriKpi);
            }

            if (isAlreadyLoaded) continue;

            // Pre-imposta array vuoto per evitare chiamate duplicate
            this.arrayUm[idCategoria] = [];

            const filters: Filters[] = [
              {
                chiave: 'idCategoriaUnitaDiMisura',
                operator: 'eq',
                values: [idCategoria],
              },
            ];

            const observable = this._temporaryToken
              ? this.unitaDiMisuraService.getUnitaDiMisuraConTempToken(
                  this._temporaryToken,
                  0,
                  1000,
                  '',
                  filters,
                )
              : this.unitaDiMisuraService.getUnitaDiMisura(0, 1000, '', filters);

            this.spinnerOver.show();
            observable.pipe(finalize(() => this.spinnerOver.hide())).subscribe((um) => {
              this.arrayUm[idCategoria] = um?.content || [];
            });
          }
        }
      }
    }
  }

  /**
   * Mi creo una mappa di tipo ['idAmbito' : punteggio] per visualizzare il
   * punteggio in tempo reale nel momento della compilazione dell'assessment
   * @param compilazione
   * @returns
   */
  valorizzaMappaPunteggio(compilazione: CompilaTematiche) {
    let mappaPunteggio: { [key: string]: any } = {};

    compilazione?.ambiti.forEach((ambito: any) => {
      mappaPunteggio[ambito.id] = ambito?.punteggioPercentuale;
    });

    this.mappaPunteggioAmbiti = mappaPunteggio;
  }

  onRadioChange(event: MatRadioChange, idxAmb: number, idxTem: number) {
    if (event instanceof MatRadioChange) {
      //Aggiunto per risolvere il glitch di visualizzazione, prendeva un event non di tipo MatRadioChange

      this.ambiti[idxAmb].tematiche[idxTem].risposte = [event.value];

      this.ambiti[idxAmb].tematiche[idxTem][this.risposteDaCiclare].forEach((opt, idx) => {
        if (opt.chiave !== event.value) {
          this.ambiti[idxAmb].tematiche[idxTem][this.risposteDaCiclare][idx].sottoRisposte = [];
        }
      });

      //risposte
      this._updateSwiperHeight();
    }
  }

  /**
   * Vale solo per l'assessment
   * Auto check di alcune risposte per il parametro della tematica min livello risposta
   * @param indexRisp
   * @param minLvRisp
   * @param tematica
   * @param opz
   */
  private _checkMultiLivello(indexRisp: number, minLvRisp: number, tematica: Tematica, opz: any) {
    tematica.risposte ??= [];

    if (indexRisp < minLvRisp) {
      // prime due risposte, dececkano tutto
      for (let i = 0; i < tematica[this.risposteDaCiclare]?.length; i++) {
        const opzPrec = tematica[this.risposteDaCiclare][i];

        if (opzPrec.chiave !== opz.chiave) {
          const idxDaDecheck = tematica.risposte.indexOf(opzPrec.chiave);
          if (idxDaDecheck >= 0) {
            tematica.risposte.splice(idxDaDecheck, 1);
          }
        }
      }
    } else {
      // Devono essere checkate anche le checkbox prima;
      // Si ciclano tutte le opzioni della tematica fino a che
      // non si trova l'opzione checkata da interfaccia.
      for (let i = 0; i < tematica[this.risposteDaCiclare]?.length; i++) {
        const opzPrec = tematica[this.risposteDaCiclare][i];

        if (i < minLvRisp) {
          // le prime due si decheckano automaticamente
          const idxDaDecheck = tematica.risposte.indexOf(opzPrec.chiave);
          if (idxDaDecheck >= 0) {
            tematica.risposte.splice(idxDaDecheck, 1);
          }
          continue;
        }

        if (opzPrec.chiave !== opz.chiave) {
          if (tematica.risposte.indexOf(opzPrec.chiave) < 0) {
            tematica.risposte.push(opzPrec.chiave);
          }
        } else {
          // Trovata l'opzione checkata, si esce
          break;
        }
      }
    }
  }

  private _deCheckMultiLivello(indexRisp: number, minLvRisp: number, tematica: Tematica, opz: any) {
    tematica.risposte ??= [];

    if (indexRisp < minLvRisp) {
      // prime due risposte, Non si fa niente
    } else {
      // Devono essere de-checkate anche le checkbox prima;
      // Si ciclano tutte le opzioni e si de-checkano tutte quelle
      // successive a quella de-checkata.
      let trovata = false;
      for (let i = 0; i < tematica[this.risposteDaCiclare]?.length; i++) {
        const opzPrec = tematica[this.risposteDaCiclare][i];

        if (opzPrec.chiave !== opz.chiave) {
          if (trovata) {
            // Era stata trovata la check de-cehckata da interfaccia, da ora in avanti si de-checka tutto
            const idxDaDecheck = tematica.risposte.indexOf(opzPrec.chiave);
            if (idxDaDecheck >= 0) {
              tematica.risposte.splice(idxDaDecheck, 1);
            }
          }
        } else {
          // Trovata l'opzione checkata, si segna e si prosegue
          trovata = true;
        }
      }
    }
  }

  /**
   * Metodo check opzione
   * @param event
   * @param tematica
   * @param opz
   * @returns
   */
  cambioCheckOpzione(event: any, tematica: Tematica, opz: any) {
    tematica.risposte ??= [];

    const indexRisp = tematica[this.risposteDaCiclare].findIndex(
      (opzList) => opzList.chiave === opz.chiave,
    );

    const idx = tematica.risposte.indexOf(opz.chiave);
    const minLvRisp = (tematica.minLivelloRispostaAutomatica ?? 3) - 1;

    if (event.checked) {
      // CHECKATO

      if (idx < 0) {
        tematica.risposte.push(opz.chiave);
      }

      if (this.isVsme) {
        this._updateSwiperHeight();
        return;
      }

      this._checkMultiLivello(indexRisp, minLvRisp, tematica, opz);
    } else {
      // DE-CHECKATO

      if (idx >= 0) {
        tematica.risposte.splice(idx, 1);
      }

      if (this.isVsme) {
        this._updateSwiperHeight();
        return;
      }

      this._deCheckMultiLivello(indexRisp, minLvRisp, tematica, opz);
    }

    this._updateSwiperHeight();
  }

  sottoOpzAzioneKpiChecked(event: any, opzSec: any) {
    this.cambioCheckSottoOpzione(event, opzSec);
    this._updateSwiperHeight();
  }

  cambioCheckSottoOpzione(event: any, opzSec: any) {
    opzSec.checked = event.checked;
  }

  checkSotto(sottoRisposte: string[] | undefined, chiave: string) {
    const isRisposta = sottoRisposte?.find((risp) => {
      return risp === chiave;
    });

    if (isRisposta) {
      return true;
    } else {
      return false;
    }
  }

  onSlideChange() {
    this.indexAmbitoCorrente = this.swiperAmbiti.nativeElement.swiper.realIndex;

    this.indexTematicaCorrente =
      this.swiperTematiche.get(this.indexAmbitoCorrente)?.nativeElement.swiper.realIndex || 0;

    const passateTema = this.ambiti
      .slice(0, this.indexAmbitoCorrente)
      .map((amb) => amb.tematiche.length)
      .reduce((pre, curr) => {
        return pre + curr;
      }, 0);

    this.currentSlideIndex = passateTema + this.indexTematicaCorrente;

    this._updateSwiperHeight();
  }

  async avanti() {
    if (this.disableForm) {
      this.avantiSlide();
      return;
    }

    if (this.isVsme && !this.ctrElementoCheckato()) {
      return;
    }

    if (this.currentSlideIndex + 1 === this.totTematiche && this.isAutovalutazione) {
      const dialog = this.utilityService.openDialog({
        titolo: 'Confermare dati inseriti?',
        descrizione: 'Non sarà più possibile modificarli',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }

      if (this.isAutovalutazione && this.compilazione) {
        this.compilazione.stato = 'PUBBLICATO';
      }
    }

    if (this.compilazione) {
      if (this.isAutovalutazione) {
        this.compilazione.tipo = 'AUTOVALUTAZIONE';
      } else if (this.isVsme) {
        this.compilazione.tipo = 'REPORT_VSME';
      }
    }

    if (!this._salva) {
      console.warn('NESSUN METODO SALVATAGGIO PASSATO');
      return;
    }

    this._salva(this.idModulo, this.compilazione).subscribe({
      next: (esito) => {
        if (esito) {
          this.avantiSlide();
        }
      },
      error: (err) => {
        console.error('ERRORE PUBBLICAZIONE COMPILAZIONE : ', err);

        this.utilityService.openDialog({
          titolo: 'Salvataggio non riuscito',
          descrizione: err?.error?.message || 'Errore nel salvataggio',
          bottoni: [{ nome_btn: 'Chiudi' }],
        });
      },
    });
  }

  /**
   * Gestione slide next
   */
  avantiSlide() {
    const totTematiche =
      this.ambiti[this.swiperAmbiti.nativeElement.swiper.realIndex].tematiche.length;

    if (this.currentSlideIndex + 1 === this.totTematiche && !this.disableForm) {
      this.completato.emit(true);
    } else {
      if (
        totTematiche ===
        (this.swiperTematiche.get(this.swiperAmbiti.nativeElement.swiper.realIndex)?.nativeElement
          .swiper.realIndex || 0) +
          1
      ) {
        this.swiperAmbiti.nativeElement.swiper.slideNext();
      } else {
        this.swiperTematiche
          .get(this.swiperAmbiti.nativeElement.swiper.realIndex)
          ?.nativeElement.swiper.slideNext();
      }
    }
  }

  indietro() {
    if (this.isVsme && !this.ctrElementoCheckato()) {
      return;
    }

    if (this.currentSlideIndex === 0 && !this.disableForm) {
      this.completato.emit(true);
    }

    if (
      (this.swiperTematiche.get(this.swiperAmbiti.nativeElement.swiper.realIndex)?.nativeElement
        .swiper.realIndex || 0) === 0
    ) {
      this.swiperAmbiti.nativeElement.swiper.slidePrev();
      this.swiperTematiche
        .get(this.swiperAmbiti.nativeElement.swiper.realIndex)!
        .nativeElement.swiper.slideTo(
          this.swiperTematiche.get(this.swiperAmbiti.nativeElement.swiper.realIndex)!.nativeElement
            .swiper?.slides.length - 1,
        );
    } else {
      this.swiperTematiche
        .get(this.swiperAmbiti.nativeElement.swiper.realIndex)
        ?.nativeElement.swiper.slidePrev();
    }
  }

  /**
   * Update dell'altezza dello swiper, perchè ha un'altezza dinamica in base al contenuto
   */
  private _updateSwiperHeight() {
    setTimeout(() => {
      this.swiperTematiche.forEach((swiper) => {
        swiper.nativeElement.swiper.update();
      });
      this.swiperAmbiti.nativeElement.swiper.update();
    }, 100);
  }

  /**
   * Genero l'oggetto della tabella da passare al componente tabella dinamica, per visualizzarla
   * @param opzSec
   * @returns
   */
  generaOggettoTabella(opzSec: OpzioneTematica) {
    const objTabella: TabellaDinamica = {
      colonne: opzSec.colonne,
      id: opzSec.id,
      righe: opzSec.righe,
      totaleColonne: opzSec.totaleColonne,
      totaleRighe: opzSec.totaleRighe,
      titoloTabella: opzSec.titoloTabella,
    };

    return objTabella;
  }

  aggiornaTabella(tabellaAggiornata: TabellaDinamica, opzSec: OpzioneTematica) {
    opzSec.colonne = tabellaAggiornata.colonne;
    opzSec.righe = tabellaAggiornata.righe;
    opzSec.totaleColonne = tabellaAggiornata.totaleColonne;
    opzSec.totaleRighe = tabellaAggiornata.totaleRighe;
  }

  /**
   * se ho modificato la dimensione della celle della tabella allora devo renderizzare l'altezza dello swiper
   * @param variazioneDimensioneCelle
   */
  renderizzaSwiper(variazioneDimensioneCelle: boolean) {
    if (variazioneDimensioneCelle) {
      this._updateSwiperHeight();
    }
  }

  public referente: string = '';
  /**
   * Metodo che mi valorizza il tooltip della della figura
   * @param figura figura
   */
  toolTipFigura(figura: any): string {
    let tooltip: string | undefined = undefined;
    if (figura) {
      tooltip = figura?.figura + ' : ' + figura?.nome;
    } else {
      tooltip = this.referente;
    }

    return tooltip;
  }

  /**
   * Funzione che mi prende la figura referente\
   */
  private _listaFigureAz() {
    const idAzienda = this.compilazione?.idAzienda;
    if (idAzienda) {
      this.spinnerOver.show();
      this.aziendaService
        .getFigureAz(idAzienda, 0, 1000)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (esito) => {
            this.referente = esito.content
              .filter((item: any) => item.figura.toLowerCase() === 'referente')
              .map((item: any) => item.figura + ' : ' + item.nome);
          },
          error: (err) => {
            console.error(err);
          },
        });
    }
  }

  /**
   * Associazione della figura aziendale alla risposta
   * Prima di assegnare una figura, salvo l'oggetto, così da non perdere i dati e avere tutto aggiornato
   * Dopo il salvataggio gestisco l'assegnazione della figura.
   * @param idAmbito
   * @param idTematica
   * @param chiaveRisposta
   * @param sottoRisposta
   * @param figura
   * @returns
   */
  async associaFiguraAziendale(
    idAmbito: string,
    idTematica: string,
    chiaveRisposta: string,
    sottoRisposta: any,
    figura: any,
  ): Promise<void> {
    if (this._salva) {
      const esitoSalvataggio = await firstValueFrom(this._salva(this.idModulo, this.compilazione));
      if (!esitoSalvataggio) return;
    }

    const dialogAssociaFiguraAziendale = this.dialog.open(DialogAssociaFiguraAziendaleComponent, {
      data: {
        figura: figura,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });
    dialogAssociaFiguraAziendale.afterClosed().subscribe((idFigura) => {
      if (idFigura) {
        this.salvaFigAz(idAmbito, idTematica, chiaveRisposta, sottoRisposta, idFigura);
      }
    });
  }

  /**
   * Salvataggio della figura una volta scelta.
   * l'ep mi ritorna la sotto risposta aggiornata con la figura e lo assegno all'oggetto, per visualizzare la figura assegnata
   * @param idAmbito
   * @param idTematica
   * @param chiaveRisposta
   * @param sottoRisposta
   * @param idFigAziendale
   */
  salvaFigAz(
    idAmbito: string,
    idTematica: string,
    chiaveRisposta: string,
    sottoRisposta: any,
    idFigAziendale: string,
  ) {
    this.spinnerOver.show();

    this.reportVsmeService
      .putAssegnaFiguraElementoVsme(
        this.idModulo,
        idAmbito,
        idTematica,
        chiaveRisposta,
        sottoRisposta.id,
        idFigAziendale,
      )
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          Object.assign(sottoRisposta, esito);
        },
        error: (err) => {
          console.error('Errore durante il salvataggio della figura aziendale:', err);
        },
      });
  }

  /**
   * Se sono in VSME allora controllo che almeno una sottopzione sia stata selezionata
   * @returns false = controllo fallito
   */
  public ctrElementoCheckato(): boolean {
    if (!this.compilazione?.ambiti) return true;

    // 1. Controlla che almeno una sotto-opzione sia selezionata
    const hasCheckedSottoOpzione = this.compilazione.ambiti.some((amb) =>
      amb.tematiche.some((tema) =>
        tema.risposteVsme.some((risp) => tema.risposte?.includes(risp.chiave)),
      ),
    );

    if (!hasCheckedSottoOpzione) {
      this.utilityService.openSnackBar('Seleziona almeno una risposta', '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
      });
      return false;
    }

    // 2. Se una risposta è selezionata, almeno una sua sotto-opzione deve esserlo
    for (const amb of this.compilazione.ambiti) {
      for (const tema of amb.tematiche) {
        if (!this.isSottoOpzioneChecked(tema)) return false;
      }
    }

    return true;
  }

  /**
   * Passando una temtica, controllo che per ogni risposta selezionata sia stata selezionata almeno una sotto-opzione, altrimenti ritorno false e mostro un messaggio di errore
   * @param tematica
   * @returns
   */
  isSottoOpzioneChecked(tematica: Tematica): boolean {
    const risposteChecked = tematica.risposteVsme.filter((risp) =>
      tematica.risposte?.includes(risp.chiave),
    );

    const allHaveSottoChecked = risposteChecked.every((risp) =>
      risp.sottoOpzioni?.some((sotto) => sotto.checked),
    );

    if (!allHaveSottoChecked) {
      this.utilityService.openSnackBar(
        'Ogni risposta selezionata deve avere almeno una sotto-opzione selezionata',
        '',
        {
          duration: 2000,
          panelClass: ['red-snackbar'],
        },
      );
      return false;
    }
    return true;
  }

  getTooltip(preCompilazioneInfos?: string): string {
    if (preCompilazioneInfos) {
      const [codice, anno] = preCompilazioneInfos.split('_');

      switch (codice) {
        case 'PA':
          return (
            "Risposta proposta dalla Policy di Sostenibilità dell'anno " +
            anno +
            ' precedentemente associata'
          );
        case 'SA':
          return (
            "Risposta proposta dalla Sintesi di Sostenibilità dell'anno " +
            anno +
            ' precedentemente associata'
          );
        case 'AA':
          return (
            "Risposta proposta dall'Assessment dell'anno " + anno + ' precedentemente associato'
          );
        case 'BA':
          return (
            "Risposta proposta dal Report di Sostenibilità dell'anno " +
            anno +
            ' precedentemente associato'
          );
        case 'BANN':
          return "Risposta proposta dal Report di Sostenibilità dell'anno " + anno;
        case 'SANN':
          return "Risposta proposta dalla Sintesi di Sostenibilità dell'anno " + anno;
        case 'AANN':
          return "Risposta proposta dall'Assessment dell'anno " + anno;
        default:
      }
    }
    return '';
  }

  apriPopUpConsigliato(opzioneTematica: OpzioneTematica, tipo: string) {
    let info: string | undefined;
    let titolo: string | undefined;

    if (tipo === 'kpi') {
      info = opzioneTematica.valoriKpi[0].preCompilazioneInfos;
      titolo = opzioneTematica.nomeBreve;
    }

    if (tipo === 'azione') {
      info = opzioneTematica.preCompilazioneInfos;
      titolo = opzioneTematica.titolo;
    }

    let infoElementoObj: InfoElemento = {
      infos: this.tooltipInfo(info ? [info] : []),

      titoloElemento: titolo,
      obbligatorio: false,
    };

    this._bottomSheet.open(BottomSheetInfoElementiComponent, { data: infoElementoObj });
  }

  /**
   * infos: info sugli elementi non preselezionati
   * @param tematica
   * @returns
   */
  tooltipInfo(info?: string[]): string[] {
    const infoList: string[] = [];

    if (info?.length) {
      info?.forEach((info: string) => {
        const [codice, anno] = info.split('_');

        switch (codice) {
          case 'MA':
            infoList.push('Analisi di Materialità ' + '[' + anno + ']');
            break;

          case 'PA':
            infoList.push('Policy di Sostenibilità ' + '[' + anno + ']');
            break;

          case 'SA':
            infoList.push('Sintesi di Sostenibilità ' + '[' + anno + ']');
            break;

          case 'AA':
            infoList.push('Assessment di Sostenibilità ' + '[' + anno + ']');
            break;

          case 'PI':
            infoList.push('Piano di Sostenibilità ' + '[' + anno + ']');
            break;
          case 'BA':
            infoList.push('Report di Sostenibilità ' + '[' + anno + ']');
            break;
          case 'DM': {
            infoList.push('Doppia Materialità ' + '[' + anno + ']');

            break;
          }
          default:
        }
      });
    }
    return infoList;
  }

  /**
   * Get Tipo elemento per prompt AI
   * @param tipoSottoRisposta
   * @returns
   */
  getTipoElemento(tipoSottoRisposta: string): TipoElemento | undefined {
    switch (tipoSottoRisposta) {
      case 'azione':
        return 'AZIONE';

      case 'kpi':
        return 'KPI';

      case 'checkbox':
      case 'dynamic_table':
        return 'SOTTORISPOSTA';

      default:
        return undefined;
    }
  }

  /**
   * Build del oggetto da elaboreare per riperimento prompt
   * @param elemento
   * @returns
   */
  protected getElementoForAI(elemento: OpzioneTematica): ElementoForAI {
    // Definisco come estrarre il titolo in base al tipo
    const titoli: Record<OpzioneTematica['tipo'], string> = {
      azione: elemento.titolo,
      kpi: elemento.nomeBreve,
      dynamic_table: elemento.titoloTabella,
      checkbox: elemento.titolo,
    };

    return {
      id: elemento.id ?? '',
      titolo: titoli[elemento.tipo] ?? '',
      descrizione: elemento.descrizione ?? '',
    };
  }

  protected getElementoForAITematica(temtaica: Tematica): ElementoForAI {
    return {
      id: temtaica.id ?? '',
      titolo: (temtaica.nomeBreve ?? '') + (temtaica.domanda ?? ''), //aggiungere domanda
      descrizione: temtaica.descrizione ?? '',
    };
  }

  /**
   * Gestisce il ridimensionamento delle textarea per aggiornare l'altezza degli Swiper.
   */
  private resizeSwiperAfterTextAreaResized() {
    // Evita sovraccarichi: esegue l'update solo dopo 50ms di inattività nel ridimensionamento
    this.resizeSubject.pipe(debounceTime(50)).subscribe(() => {
      console.log('ridimnens');

      this.forceSwiperUpdate();
    });

    // Reagisce dinamicamente alla comparsa/scomparsa delle textarea nel DOM (es. slide diverse)
    effect(() => {
      // Rimuove i vecchi observer per evitare duplicati o perdite di memoria
      this.cleanupObservers();

      this.textAreas().forEach((ref) => {
        // Notifica il subject ad ogni variazione di dimensione della textarea
        const ro = new ResizeObserver(() => this.resizeSubject.next());

        // Attiva il monitoraggio fisico dell'elemento textarea nel DOM
        ro.observe(ref.nativeElement);

        // Registra l'observer nell'elenco dei processi attivi per poterlo distruggere
        // ed evitare perdite di memoria (memory leak) al cambio slide o distruzione del componente
        this.observers.push(ro);
      });
    });
  }
  /**
   * Forza l'aggiornamento del layout di tutti gli Swiper (tematiche e ambiti).
   */
  private forceSwiperUpdate() {
    this.swiperTematiche?.forEach((swiper) => {
      swiper.nativeElement.swiper?.update();
    });
    this.swiperAmbiti?.nativeElement.swiper?.update();
  }

  /**
   * Scollega tutti i ResizeObserver attivi per evitare memory leak.
   */
  private cleanupObservers() {
    this.observers.forEach((ro) => ro.disconnect());
    this.observers = [];
  }
}
